/** Default message for all loaders unless a route override matches. */
export const LOADER_DEFAULT_MESSAGE = 'Loading Secure Payments';

/**
 * Optional per-section messages (longest prefix wins).
 * Add entries here when a route should show context-specific text.
 */
export const LOADER_ROUTE_MESSAGES: ReadonlyArray<{ prefix: string; message: string }> = [
  { prefix: '/admin', message: 'Loading Admin Panel' },
  { prefix: '/dashboard/withdrawals', message: 'Loading Withdrawals' },
  { prefix: '/dashboard', message: 'Loading Dashboard' },
  { prefix: '/withdrawals', message: 'Loading Withdrawals' },
  { prefix: '/wallet', message: 'Loading Wallet' },
  { prefix: '/invoices', message: 'Loading Invoices' },
  { prefix: '/transactions', message: 'Loading Transactions' },
  { prefix: '/pay/', message: 'Loading Checkout' },
];

export function resolveLoaderMessage(pathname: string): string {
  const normalized = pathname.endsWith('/') && pathname.length > 1
    ? pathname.slice(0, -1)
    : pathname;

  const match = [...LOADER_ROUTE_MESSAGES]
    .sort((a, b) => b.prefix.length - a.prefix.length)
    .find(({ prefix }) => normalized === prefix || normalized.startsWith(`${prefix}/`));

  return match?.message ?? LOADER_DEFAULT_MESSAGE;
}
